import { useEffect, useState } from "react";

export function isPlatformSafari(): boolean {
  return (
    typeof navigator !== "undefined" &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
}

/**
 * Allows accessing the platform check through a hook that avoid hydration
 * issues when rendered in Next.JS
 */
export function usePlatformSafari() {
  const [isMatch, setIsMatch] = useState(false);

  useEffect(() => {
    setIsMatch(isPlatformSafari());
  }, []);

  return isMatch;
}
